// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__upkmr","breadcrumb":"Breadcrumbs_breadcrumb__u+z7k","separator":"Breadcrumbs_separator__W+FTA"};